export default __webpack_public_path__ + "static/media/whale.5595ac27.png";